"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MILESTONE_RELATIONS = void 0;
exports.MILESTONE_RELATIONS = {
    HEALTH: {
        GROWTH: {
            DIET: {},
            EXERCISE: {}
        },
        GROOMING: {
            HAIR: {},
            NAILS: {},
            TEETH: {}
        },
        MEDICAL: {
            VETERINARY: {},
            INSURANCE: {}
        }
    },
    TRAINING: {
        WALKING: {},
        SOCIAL: {}
    }
};
